import "./App.css";
import { Route, Routes, useNavigate, Navigate, useLocation } from "react-router-dom";
import Login from "./pages/Login";
import { Amplify } from "aws-amplify";
import { getCurrentUser } from "aws-amplify/auth";
import awsconfig from "./aws-exports";
import { useEffect, useState } from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import DashBoard from "./pages/Dashboard";
import History from "./pages/History";
import SendPTCReportConfirm from "./pages/SendPTCReportConfirm";
import SendMonthlySnapshotReportConfirm from "./pages/SendMonthlySnapshotReportConfirm";
import ApiLog from "./pages/ApiLog";

const PUBLIC_ROUTES = ["/login"];

Amplify.configure(awsconfig);
function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const isPublicRoute = PUBLIC_ROUTES.some((route) =>
      location.pathname.toLowerCase().startsWith(route.toLowerCase())
    );

    if (isPublicRoute) {
      setLoading(false);
      return;
    }

    const checkAuth = async () => {
      try {
        await getCurrentUser();
        setLoading(false);
      } catch {
        navigate("/login");
        setLoading(false);
      }
    };
    checkAuth();
  }, [location.pathname, navigate]);

  if (loading) {
    return (
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={<DashBoard />} />
      <Route path="/history" element={<History/>} />
      <Route path="/api-log" element={<ApiLog />} />
      <Route path="/send-ptc-report/confirm" element={<SendPTCReportConfirm />} />
      <Route path="/send-monthly-snapshot/confirm" element={<SendMonthlySnapshotReportConfirm />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default App;
